import Model from './model.js'
import Payment from './payment.js'

export default class Invoice extends Model {
	_constructor() {
		if (this.payments != null) {
			this.payments = Payment.fill(this.payments)
		}
	}

	icon() {
		switch (true) {
			case this.status == 'Paid':
				return { icon: 'IconTick', class: 'bg-green-600/10 stroke-green-600' }
				break
			case this.status == 'Unpaid':
				return { icon: 'IconFalse', class: 'bg-red-700/10 stroke-red-700' }
				break
		}

		return { icon: 'IconTick', class: 'bg-red-600/10 stroke-red-600' }
	}

	color() {
		switch (true) {
			case this.status == 'Paid':
				return { icon: 'IconTick', class: 'text-green-600' }
				break
			case this.status == 'Unpaid':
				return { icon: 'IconFalse', class: 'text-red-700' }
				break
		}

		return { icon: 'IconTick', class: 'text-red-600' }
	}

	statusView() {
		switch (this.status) {
			case 'Paid':
				return 'Invoice paid'
				break
			default:
				return this.status
		}
	}
}
